import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const CreateAccount: React.FC = () => {
  const content = (
    <>
      <h2>Opret din DoMore konto</h2>
      <p>
        At oprette en konto på DoMore er nemt og tager kun få minutter. Følg denne trin-for-trin guide for at komme i gang.
      </p>

      <h3>Trin 1: Gå til tilmeldingssiden</h3>
      <p>
        Klik på "Tilmeld dig" knappen i øverste højre hjørne af hjemmesiden. Du vil blive dirigeret til tilmeldingsformularen.
      </p>

      <h3>Trin 2: Udfyld dine oplysninger</h3>
      <p>Du skal indtaste følgende informationer:</p>
      <ul>
        <li><strong>Navn:</strong> Dit fulde navn</li>
        <li><strong>Email:</strong> En gyldig email-adresse</li>
        <li><strong>Adgangskode:</strong> Vælg en sikker adgangskode (minimum 8 tegn)</li>
        <li><strong>By:</strong> Din by eller postnummer</li>
      </ul>

      <h3>Trin 3: Bekræft din email</h3>
      <p>
        Efter registrering sender vi en bekræftelsesmail til din email-adresse. Klik på linket i emailen for at aktivere din konto.
      </p>

      <h3>Trin 4: Udfyld din profil</h3>
      <p>
        Når din email er bekræftet, anbefaler vi at du udfylder din profil med:
      </p>
      <ul>
        <li>Profilbillede</li>
        <li>Kort beskrivelse om dig selv</li>
        <li>Telefonnummer (valgfrit)</li>
      </ul>

      <h3>Tips til en god profil</h3>
      <p>
        En komplet profil øger tilliden blandt brugere og gør det nemmere at leje og udleje værktøj. Husk at:
      </p>
      <ul>
        <li>Brug et venligt og professionelt profilbillede</li>
        <li>Skriv lidt om dig selv og dine interesser</li>
        <li>Vær ærlig og transparent i din kommunikation</li>
      </ul>

      <h3>Hvad nu?</h3>
      <p>
        Nu er du klar til at udforske DoMore! Du kan begynde at søge efter værktøj eller liste dit eget værktøj til udlejning.
      </p>
    </>
  );

  return (
    <HelpArticle
      title="Sådan opretter du en konto"
      category="Kom i gang"
      content={content}
      relatedArticles={[
        { title: 'Find det rigtige værktøj', link: '/help/find-tool' },
        { title: 'Foretag din første booking', link: '/help/first-booking' },
      ]}
    />
  );
};

export default CreateAccount;
